import { render, staticRenderFns } from "./createRSQuoteStep2.vue?vue&type=template&id=70ebe1ac&scoped=true&"
import script from "./createRSQuoteStep2.vue?vue&type=script&lang=js&"
export * from "./createRSQuoteStep2.vue?vue&type=script&lang=js&"
import style0 from "./createRSQuoteStep2.vue?vue&type=style&index=0&id=70ebe1ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ebe1ac",
  null
  
)

export default component.exports